document.addEventListener('DOMContentLoaded', function () {
    const btn = document.getElementById('quote-btn');
    btn.style.transition = 'opacity 0.4s ease, visibility 0.4s ease';
    btn.style.opacity = 0;
    btn.style.visibility = 'hidden';

    function isDesktop() {
        // Tailwind's md: breakpoint is 768px
        return window.innerWidth >= 768;
    }

    function isAtPageEnd() {
        // Checks if user is at (or near) the bottom of the page
        return (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 10);
    }

    function toggleBtn() {
        if (!isDesktop()) {
            btn.classList.add('hidden');
            btn.style.opacity = 0;
            btn.style.visibility = 'hidden';
            return;
        }
        if (window.scrollY > 350 && !isAtPageEnd()) {
            btn.classList.remove('hidden');
            setTimeout(() => {
                btn.style.opacity = 1;
                btn.style.visibility = 'visible';
            }, 10);
        } else {
            btn.style.opacity = 0;
            btn.style.visibility = 'hidden';
            setTimeout(() => {
                if (window.scrollY <= 350 || isAtPageEnd()) btn.classList.add('hidden');
            }, 400);
        }
    }
    window.addEventListener('scroll', toggleBtn);
    window.addEventListener('resize', toggleBtn);
    toggleBtn();
});